
import { StyleSheet } from 'aphrodite/no-important';

const styles = StyleSheet.create({
    checkbox: {
        cursor: 'pointer',
        padding: '8px 0'
    },
    fakeCheckbox: {
        background: '#ffffff',
        border: '1px solid #DBDBDB',
        borderRadius: '2px',
        height: '12px',
        width: '12px',
        display: 'inline-block',
        textAlign: 'center',
        overflow: 'hidden',
        marginRight: '8px'
    },
    fakeCheckboxChecked: {
        background: '#ffffff',
        border: '1px solid #DBDBDB',
        borderRadius: '2px',
        height: '12px',
        width: '12px',
        display: 'inline-block',
        textAlign: 'center',
        overflow: 'hidden',
        backgroundColor: '#00c8ff',
        borderColor: '#00c8ff',
        marginRight: '8px'
    },
    fakeCheckboxCheckmark: {
        position: 'relative',
        display: 'inline-block',
        left: '-1px',
        margin: '-8px',
        verticalAlign: 'top'
    },
    fakeCheckboxCheckmarkSvg: {
        height: '26px',
        width: '20px',
        display: 'block',
        paddingLeft: '2px'
    },
    mapAutoRefresh: {
        padding: '0 8px'
    },
    mapOverlay: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 1
    },
    mapRefreshControls: {
        position: 'absolute',
        top: '10px',
        left: '75px'
    },
    mapWrapper: {
        position: 'fixed',
        visibility: 'none',
        top: '124px',
        left: '0px',
        bottom: '0px',
        right: '0px',
        width: '100%',
        '@media (min-width: 1128px)': {
            display: 'block',
            left: 'auto',
            width: '34%'
        }
    },
    mapWrapper_withTabs: {
        top: '124px'
    },
    mapPanelHidden: {
        '@media (min-width: 744px) and (max-width: 1127px)': {
            zIndex: -1
        },
        '@media (max-width: 743px)': {
            zIndex: -1
        }
    },
    mapPanelVisible: {
        visibility: 'visible',
        zIndex: 50
    },
    panel: {
        border: '1px solid #dce0e0',
        backgroundColor: '#fff',
        borderRadius: 0
    },
    refreshInput: {
        display: 'none',
        position: 'absolute',
        width: '0px',
        opacity: 0
    },
    searchResultsMapContainer: {
        width: '100%',
        height: 'calc(100vh - 124px)',
        '@media (min-width: 1128px)': {
            top: '488px',
            width: '34vw'
        }
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/MapSection/styles.js